import script from "./DocMixView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocMixView.vue?vue&type=script&setup=true&lang=js"

import "./DocMixView.vue?vue&type=style&index=0&id=18c0b644&lang=scss"

const __exports__ = script;

export default __exports__